// Provenance: repo:tds-reconciliation-portal:frontend/src/components/MiniBars.tsx
// (ADR-0005) — restyled on the estate tokens (ADR-0010).
import { fmtMoney, fmtMonthKey } from '../format'

const H = 90 // px, tallest bar

/** Tiny dependency-free grouped bar chart for residuals-by-month. */
export function MiniBars({ data }: { data: Record<string, { as26: number; books: number }> }) {
  const entries = Object.entries(data)
    .filter(([k]) => k !== 'unknown')
    .sort(([a], [b]) => a.localeCompare(b))
  const unknown = data['unknown']
  const max = Math.max(1, ...entries.flatMap(([, v]) => [Math.abs(v.as26), Math.abs(v.books)]))

  if (entries.length === 0 && !unknown) {
    return <p className="text-sm text-muted-foreground">No unmatched transactions.</p>
  }

  const bar = (value: number, cls: string, label: string) => (
    <div
      title={`${label}: ${fmtMoney(value)}`}
      className={`w-3 rounded-sm ${cls}`}
      style={{ height: Math.max(2, Math.round((H * Math.abs(value)) / max)) }}
    />
  )

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-end gap-2.5">
        {entries.map(([month, v]) => (
          <div key={month} className="flex flex-col items-center gap-0.5">
            <div className="flex items-end gap-0.5" style={{ height: H }}>
              {bar(v.as26, 'bg-indigo-500', '26AS not in books')}
              {bar(v.books, 'bg-teal-500', 'Books not in 26AS')}
            </div>
            <span className="text-[10px] text-muted-foreground">{fmtMonthKey(month)}</span>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <span className="flex items-center gap-1 text-xs text-muted-foreground">
          <span className="h-2.5 w-2.5 rounded-sm bg-indigo-500" /> 26AS not in books
        </span>
        <span className="flex items-center gap-1 text-xs text-muted-foreground">
          <span className="h-2.5 w-2.5 rounded-sm bg-teal-500" /> Books not in 26AS
        </span>
        {unknown ? (
          <span className="text-xs text-muted-foreground">
            undated: 26AS {fmtMoney(unknown.as26)} · books {fmtMoney(unknown.books)}
          </span>
        ) : null}
      </div>
    </div>
  )
}
